let slider = document.querySelector('.reviews-slider')

if(slider) {
    new Swiper(slider, {
        slidesPerView: 'auto',
        slideClass: 'review',
        loop: true,
        autoplay: {
            delay: 4000,
        },
        speed: 400
    })
}